'use client';

import { c as _c } from "react/compiler-runtime";
import { SavedViewsPanelHost } from '@context/saved-views';
import { SavedViewsPanelProvider, TableConfigurationProvider } from '@repo/table/table-configuration';
import type { PropsWithChildren } from 'react';
import { loadsTableConfiguration } from './loads-table-configuration';
export const LoadsTableConfigurationProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SavedViewsPanelHost data-sentry-element="SavedViewsPanelHost" data-sentry-source-file="loads-table-configuration-provider.tsx" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <TableConfigurationProvider definition={loadsTableConfiguration} data-sentry-element="TableConfigurationProvider" data-sentry-component="LoadsTableConfigurationProvider" data-sentry-source-file="loads-table-configuration-provider.tsx"><SavedViewsPanelProvider data-sentry-element="SavedViewsPanelProvider" data-sentry-source-file="loads-table-configuration-provider.tsx">{children}{t1}</SavedViewsPanelProvider></TableConfigurationProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};